module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C152"
  }, [_c('a', {
    attrs: {
      "id": "cont"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "cont"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "cont"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/03_By_way_of_introduction"
    }
  }, [_vm._v("By way of introduction . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/04_No_one_can_say_what_quantum_mech"
    }
  }, [_vm._v("No one can say what quantum mechanics means (and this is a book about it)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/05_Quantum_mechanics_is_not_really"
    }
  }, [_vm._v("Quantum mechanics is not really about the quantum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_Quantum_objects_are_particle__bu"
    }
  }, [_vm._v("Quantum objects are neither wave nor particle (but sometimes they might as well be)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_Quantum_particles_aren_t__but_so",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quantum particles aren't in two states at once (but sometimes they might as well be)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_What__happens__depends_on_what_w",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What ‘happens’ depends on what we find out about it")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_There_are_many_ways_of_theory__a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There are many ways of interpreting quantum theory (and none of them quite makes sense)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_Whatever_the_question__the_answe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whatever the question, the answer is ‘Yes’ (unless it’s ‘No’)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_Not_everything_is_knowable_at_on",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not everything is knowable at once")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_The_properties_of_quantum_object",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The properties of quantum objects don’t have to be contained within the objects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_There_is_no__spooky_action_at_a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There is no ‘spooky action at a distance’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_The_everyday_world_is_what_quant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The everyday world is what quantum becomes at human scales")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_Everything_you_experience_is_a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Everything you experience is a (partial) copy of what causes it")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_Schr_dinger_s_cat_has_had_kitten",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schrödinger’s cat has had kittens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_Quantum_mechanics_can_be_harness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quantum mechanics can be harnessed for technology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_Quantum_computers_don_t_necessar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quantum computers don’t necessarily perform ‘many calculations at once’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_There_is_no_other__quantum__you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There is no other ‘quantum’ you")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_Things_could_be_even_more__quant",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Things could be even more ‘quantum’ than they are (so why aren’t they)?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_The_fundamental_laws_of_quantum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The fundamental laws of quantum mechanics might be simpler than we imagine")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_Can_we_ever_get_to_the_bottom_of",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Can we ever get to the bottom of it?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/24_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/25_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/26_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3ebb84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/03_Contents.vue
// module id = 63
// module chunks = 0